import {AUTH} from './actions';

export const auth = (state = {}, action) => {
  switch (action.type) {
    case AUTH:
      return action.value.oauthInfo;
    default:
      return state;
  }
};
